module.exports = __webpack_public_path__ + "static/covid19_card_img1@2x-d8080ab959ff580a8d5ad151194d6c37.jpg";